<template>
  <div class="email">
    <Navigation></Navigation>
    <div class="bg"></div>
    <div class="mb_cartoon_bg"></div>
    <img
      src="../assets/images/back_btn.png"
      alt=""
      class="back_btn"
      @click="goback"
    />
    <div class="email_content">
      <img src="../assets/images/qa.png" alt="" class="qa_title" />
      <ul class="qa_ul clearfix">
        <li class="qa_li" @click="goQaDetail(1)">
          <img src="../assets/images/qa_icon_1.png" alt="" />
        </li>
        <li class="qa_li" @click="goQaDetail(2)">
          <img src="../assets/images/qa_icon_2.png" alt="" />
        </li>
        <li class="qa_li" @click="goQaDetail(3)">
          <img src="../assets/images/qa_icon_3.png" alt="" />
        </li>
        <li class="qa_li" @click="goQaDetail(4)">
          <img src="../assets/images/qa_icon_4.png" alt="" />
        </li>
      </ul>
      <a href="mailto:ouore_service@szckhd.com" class="email_title">
        <img src="../assets/images/email.png" alt="" class="qa_title" />
      </a>
      <!-- <ul class="qa_ul clearfix">
                <li class="qa_li" @click="goEmailDetail(1)">
                    <img src="../assets/images/email_icon_1.png" alt="">
                </li>
                 <li class="qa_li" @click="goEmailDetail(2)">
                    <img src="../assets/images/email_icon_2.png" alt="">
                </li>
                 <li class="qa_li" @click="goEmailDetail(3)">
                    <img src="../assets/images/email_icon_3.png" alt="">
                </li>
                 <li class="qa_li" @click="goEmailDetail(4)">
                    <img src="../assets/images/email_icon_4.png" alt="">
                </li>
            </ul> -->
    </div>
    <!-- <div class="line"></div> -->
    <div class="email_footer">
      <h3>
        お問い合わせ類型について（場合によって、下記の情報を提供してください）
      </h3>
      <h5>※不具合に関する質問</h5>
      <p>
        1、ID；2、サーバ；3、ご利用OS(例: iOS11.3.1)；4、ご利用機種(例:
        iPhone7)；5、アプリのバージョン(例:
        ver1.1.1)；6、ゲームをプレイする際の通信環境（NTTドコモやSoftbankなど。複数ある場合には、すべてご記入ください。)；7、不具合確認日時；8、詳細説明。
      </p>
      <h5>※アプリへのご要望（返信なし）</h5>
      <p>
        ご要望などをいただいたメールには原則、ご返信しておりません。あらかじめご了承ください。<br />1、ID；2、サーバ；3、ご意見。
      </p>
      <h5>※そのほかのお問い合わせ</h5>
      <p>
        1、ID；2、サーバ；3、ご利用OS(例: iOS11.3.1)；4、ご利用機種(例:
        iPhone7)；5、アプリのバージョン(例:
        ver1.1.1)；6、ゲームをプレイする際の通信環境（NTTドコモやSoftbankなど。複数ある場合には、すべてご記入ください。)；7、不具合確認日時；8、お問い合わせ内容。
      </p>
      <div class="line"></div>
      <h3>返信について</h3>
      <p>
        ●
        お問い合わせいただいたご質問について、全てへの返信はおこなっておりません。また、原則として【返答なし】のフォームについては個別の返答はおこなっておりませんが、ご連絡いただいた内容は全て確認し、改善に努めさせていただいております。
      </p>
      <p>
        ●
        全体的な不具合が発生していた場合には、運営サイトの「お知らせ」などにてご案内しております。こちらをもって返信とかえさせていただく場合がございます。
      </p>
      <p>
        ●
        ゲーム内の仕様に関するご質問、およびご意見やお知らせにてご案内している不具合および障害の報告などについては、原則ご案内しておりません。
      </p>
      <p>
        ●
        お問い合わせには可能な限り早く返信いたしますが、内容や状況によってはお時間をいただきます。
      </p>
      <p>
        ●
        返信の際は、お問い合わせいただいたメールアドレスへのみ返信をいたします。
      </p>
      <p>
        ドメイン指定などを行っている場合「王に俺はなる」を受信できるように設定を変更してください。
      </p>
    </div>
  </div>
</template>

<script>
import Navigation from "../components/navigation";
import api from "@/api";
export default {
  name: "cartoon",
  components: {
    Navigation,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goback() {
      this.$router.push("/");
    },
    goQaDetail(id) {
      this.$router.push(`/qaDetail?qaId=${id}`);
    },
    goEmailDetail(id) {
      this.$router.push(`/emailDetail?eId=${id}`);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bg {
  background: url("../assets/images/news_bg.png") no-repeat;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.mb_cartoon_bg {
  background: url("../assets/images/mb_news_bg.png") no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: none;
}
.email {
  width: 100%;
  height: 100%;
  text-align: left;
}
.back_btn {
  width: 232px;
  margin-top: 150px;
  margin-left: 80px;
  cursor: pointer;
  visibility: hidden;
}
.qa_title {
  width: 600px;
}
.email_title {
  display: block;
  width: 800px;
  margin: 50px auto;
  img {
    width: 100%;
  }
}
.email_content {
  width: 70%;
  position: relative;
  top: 0px;
  left: 50%;
  text-align: center;
  transform: translateX(-50%);
  .qa_ul {
    display: flex;
    .qa_li {
      flex: 1;
      margin: 100px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
  }
}
.line {
  width: 100%;
  height: 3px;
  background-color: #999;
  margin-top: 50px;
  margin-bottom: 50px;
}
.email_footer {
  width: 80%;
  margin: 0 auto;
  border-top: 3px solid #999;
  padding-top: 50px;
  h3 {
    font-size: 60px;
    margin-bottom: 25px;
    font-weight: 500;
  }
  h5 {
    font-size: 40px;
    margin-bottom: 25px;
    font-weight: 500;
  }
  p {
    font-size: 40px;
    margin-bottom: 30px;
  }
}
.hiddentoken {
  display: none;
}

// 移动端
@media screen and (max-width: 750px) {
  .news_tags {
    li {
      font-size: 30px;
    }
  }
  .bg {
    display: none;
  }
  .mb_cartoon_bg {
    display: block;
  }
  .back_btn {
    width: 400px;
    margin-top: 400px;
  }
  .qa_title {
    width: 1000px;
  }
  .email_content {
    width: 100%;
    .qa_ul {
      display: block;
      .qa_li {
        display: inline-block;
        width: 30%;
        height: 1500px;
        margin: 200px;
        img {
          vertical-align: top;
        }
      }
    }
  }
  .line {
    height: 10px;
    background-color: #666;
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .email_footer {
    width: 80%;
    border-top: 10px solid #666;
    padding-top: 100px;
    h3 {
      font-size: 200px;
      margin-bottom: 50px;
    }
    h5 {
      font-size: 150px;
    }
    p {
      font-size: 150px;
      margin-bottom: 80px;
    }
  }
  .email_title {
    width: 1500px;
  }
}
</style>
